import React from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import FormLabel from 'react-bootstrap/FormLabel';
import FormGroup from 'react-bootstrap/FormGroup';
import Row from 'react-bootstrap/Row';
import { Helmet } from 'react-helmet';
import { generatePath, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';

import { therapeuticCategoriesEditRoute, therapeuticCategoriesRoute } from 'App/common/routeLookup';
import { addTherapy } from '../../services/AdminService';
import { catchPhrase } from '../config/config';
import { Text } from '../StandaloneFormField';
import PageHeader from '../styles/PageHeader/PageHeader';
import PageTitle from '../styles/PageTitle/PageTitle';
import PageWrapper from '../styles/PageWrapper/PageWrapper';

const schema = Yup.string().required('Name is required');

const propTypes = {};

const defaultProps = {};

function CreateCategoryPage() {
    //#region State
    const navigate = useNavigate();
    //#endregion

    //#region Click/Action/Event Handlers
    const gotToLandingPage = () => navigate(therapeuticCategoriesRoute);
    //#endregion

    return (
        <>
            <Helmet>
                <title>New Therapeutic Category - {catchPhrase}</title>
            </Helmet>

            <PageTitle>New Therapeutic Category</PageTitle>

            <PageWrapper>
                <PageHeader>
                    <Row style={{ width: '100%' }}>
                        <Col md={6}>
                            <Row>
                                <Col sm={12}>
                                    <FormGroup>
                                        <FormLabel htmlFor="name" className="field-required">
                                            Name
                                        </FormLabel>
                                        <Text
                                            id="name"
                                            placeholder="Name"
                                            onSave={(name) => {
                                                return addTherapy(name).then(({ id }) => {
                                                    navigate(generatePath(therapeuticCategoriesEditRoute, { therapyId: id }));
                                                });
                                            }}
                                            validator={(value) => {
                                                return schema.validate(value);
                                            }}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={12}>
                                    <div className="form-button-group">
                                        <Button variant="outline-secondary" type="button" onClick={gotToLandingPage}>
                                            Cancel
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </PageHeader>
            </PageWrapper>
        </>
    );
}

CreateCategoryPage.propTypes = propTypes;
CreateCategoryPage.defaultProps = defaultProps;

export default CreateCategoryPage;
